import React from "react";
import { CardContent ,Card } from "@material-ui/core";
import { Grid ,Typography} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import { usageService } from "../service/e_service";
import { useEffect } from "react";
import { useState } from "react";
import { store } from "../../../../helpers";
import { useMediaQuery } from "react-responsive";
import E_CheckboxListSecondary from "./e_list_view";
import E_RateSimulator from "./e_rate_simuator";
import { commonService } from "../../../../services/common.service";
import E_CO2_EMISSION from "../../e_co2_emission/e_co2_emission";
import { adminService } from "../../../../services/admin.service";
import CircularProgress from "@material-ui/core/CircularProgress";


const useStyles = makeStyles((theme) => ({

    baseline:{
      marginBottom : 5
    },
    image:{
           color : theme.palette.ePrimary?.base ,                 
           align : "center",
            marginTop :5,
           marginBottom:10,
           },
    imageMobileHeight:{
      height : "2vh"
    },
    imageHeight:{
      height : "2.8vh"
    },
    imageFont:{
      fontSize : "0.875rem",
      fontWeight:"bold",
      marginLeft:5
    },
    imageMobileFont:{
      fontSize : "0.75rem",
      fontWeight:"bold",
      marginLeft:5
    },
    chartOnly :{
      height: "100%"
    },
    chartSize:{
      height:"64.3vh"
    },
    energyPlansGrid: {
      width: "100%"
    },
    mobileEmissionCard: {
      height: "50vh"
    },
    mobileEmissionCardContent: {
      height: "100%"
    },
    desktopRightGrid: {
      flexFlow: "column"
    },
    emissionGrid: {
      flexGrow: "1"
    },
    emissionCard: {
      height: "100%"
    },
    emissionCardContent: {
      height: "100%"
    },
    loadingButton:{
     marginTop:"15% !important"
    }
  }));
export default function E_LowestRatePlan(){
    const EnergyPlanclasses = useStyles();
      let EnergyPlansLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_SUSTAINABILITY);
      const accountId = useSelector((state) => state?.meterDetails?.accountId);
      let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
      const isMobile = useMediaQuery({ maxWidth: 550 });
      const [data,setData] = useState(null);
      const [error,setError] = useState(false);
      const [spinner,setSpinner]=useState(false)
      useEffect(()=>{
        store.getState().snackbar = true;
        if(accountId && saId){
          setData(null)
          setSpinner(true)
          usageService.getEnergyPlansDetails(saId, accountId)
          .then((response) => {    
             store.getState().snackbar = false;
             setSpinner(false)
             setData(response?.data?.getEnergyPlans)
             setError(false);
          }) 
          .catch((err) =>{
            setData(null)
            setSpinner(false)
            setError(true);
        });
        }
      },[saId, accountId])
const [rates,setRates] = useState()

const compareChange = (rateToCompare) => {
  setRates(rateToCompare);
};
const [RatePlans, setRatePlans] = useState()
const [isLowestCostRatePlan , setIsLowestCostRatePlan] = useState()
useEffect(()=>{
  setRatePlans(data?.rates);
  setIsLowestCostRatePlan(data?.isLowCostPlanExist)
},[data])
const [callNowImagePath, setCallNowImagePath] = useState("");
      let callNowImage = useSelector(
          (store) => store?.parametersWidgets?.ParameterLookup?.E_SUSTAINABILITY_CALL_NOW_IMAGE
      );
       useEffect(() => {
          if (callNowImage) {
            commonService.getAssestUrl(callNowImage).then((response) => {
              setCallNowImagePath(response);
          })
        }
      },[callNowImage]);
      let isPrepaidSa = useSelector((store) => store?.meterDetails?.getSaInfo?.isPrepaidSa);
    const [subtitle, setSubTitle] = useState("");
    let tenantName = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_NAME);
    let primaryLanguage = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
    useEffect(() => {
      if (tenantName) {
        adminService
          .getContentData(primaryLanguage, "E_SUSTAINABILITY")
          .then((res) => {
            setSubTitle(res?.data?.getContents?.E_SUSTAINABILITY?.[2]?.answer);
          })
          .catch(err => {
            setSubTitle(null);
          })
      }
    }, [primaryLanguage,tenantName]);

    useEffect(()=>{
      let enabled_state_value=localStorage.getItem("enabled_state")
      if(enabled_state_value)
      localStorage.removeItem("enabled_state")
    },[])
    
    return (

      <>
      {spinner ? 
      (
        <><Grid item xs={12} md={12} lg={12} 
        align="center" 
        className={EnergyPlanclasses.loadingButton}>
                    <CircularProgress size={40} />
                  </Grid></>
      )
      :
      (
        <>
         {isLowestCostRatePlan === "true" && isPrepaidSa === 'N' ? (
          <>
            <CardContent>
              <Grid container>
                <Grid item justify="left" xs={11} sm={6}>
                  <Typography variant="h6" gutterBottom>
                    <b>{EnergyPlansLabels?.E_YOUR_LOWEST_ENERGY_RATE_PLAN}</b>
                  </Typography>
                  {RatePlans?.map((item) => (
                    <>
                      {item.isLowestCostRatePlan === "true" && (<>
                        <Typography align="left" className={EnergyPlanclasses.baseline} variant="caption">
                          {EnergyPlansLabels?.E_SUBLINE_RATE_PLAN} {item.rateScheduleDescription} {EnergyPlansLabels?.E_RATE_PLAN}.
                        </Typography></>)}
                    </>
                  ))}
                </Grid>
  
                <Grid container className={EnergyPlanclasses.energyPlansGrid} item>
                  
                    {isMobile ? (<>
                      <Grid item xs={12} md={6} >
                        <E_RateSimulator
                          rateToCompare={rates} />
                      </Grid>
                      <Grid container direction="rows" xs={11} md={6}
                        className={EnergyPlanclasses.image}
                      >
                        {callNowImagePath && (
                          <img
                            className={EnergyPlanclasses.imageMobileHeight}
                            src={callNowImagePath?.assetPath}
                            alt={EnergyPlansLabels?.[callNowImagePath?.fallBackLabelKey]}
                          />
                        )}
                        <Typography
                          align="left"
                          className={EnergyPlanclasses.imageMobileFont}
                          variant="subtitle2"
                          dangerouslySetInnerHTML={{
                            __html: subtitle,
                          }}
                        ></Typography>
                      </Grid>
                      <Grid item xs={12} md={6} >
                        <E_CheckboxListSecondary
                          handler={compareChange} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card className={EnergyPlanclasses.mobileEmissionCard}>
                          <CardContent className={EnergyPlanclasses.mobileEmissionCardContent}>
                            <E_CO2_EMISSION />
                          </CardContent>
                        </Card>
                      </Grid>
                    </>) : (
                      <>
                        <Grid item xs={12} sm={6} >
                          <E_CheckboxListSecondary
                            handler={compareChange} />
                        </Grid>
                        <Grid className={EnergyPlanclasses.desktopRightGrid} container item xs={12} sm={6}>
                          <Grid item>
                            <E_RateSimulator
                              rateToCompare={rates} />
                          </Grid>
                          <Grid item container direction="rows"
                            className={EnergyPlanclasses.image}
                          >
                            {callNowImagePath && (
                              <img
                                className={EnergyPlanclasses.imageHeight}
                                src={callNowImagePath?.assetPath}
                                alt={EnergyPlansLabels?.[callNowImagePath?.fallBackLabelKey]}
                              />
                            )}<Typography
                              align="left"
                              className={EnergyPlanclasses.imageFont}
                              variant="subtitle2"
                              dangerouslySetInnerHTML={{
                                __html: subtitle,
                              }}
                            ></Typography>
                          </Grid>
                          <Grid className={EnergyPlanclasses.emissionGrid} item sm={12}>
                            <Card className={EnergyPlanclasses.emissionCard}>
                              <CardContent className={EnergyPlanclasses.emissionCardContent}>
                                <E_CO2_EMISSION />
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  
                </Grid>
              </Grid>
            </CardContent>
          </>
        ) : (<>
          <Grid className={EnergyPlanclasses.chartOnly}>
            <Card className={EnergyPlanclasses.chartOnly}>
              <CardContent className={EnergyPlanclasses.chartOnly}>
                <E_CO2_EMISSION />
              </CardContent>
            </Card>
          </Grid>
        </>)}
        </>
      )
      }
       
      </>
    );
}